import React from 'react'
import type { RangeKey } from '@dataTypes/dashboard.types'
import DashboardSchedulingPerformancePanel from '@components/pages/Dashboard/SchedulingPerformancePanel/DashboardSchedulingPerformancePanel.component'
import type { ScheduleOperationsOverviewResult } from '@services/api/dashboard/operations-schedule.api'

type ScheduleOperationsCardProps = {
  titleHref: string
  range: RangeKey
  loading: boolean
  scheduleOpsOverview: ScheduleOperationsOverviewResult | null
}

export function ScheduleOperationsCard({
  titleHref,
  range,
  loading,
  scheduleOpsOverview,
}: ScheduleOperationsCardProps): React.ReactElement {
  return (
    <DashboardSchedulingPerformancePanel
      title="Schedule operations"
      titleHref={titleHref}
      className="dashboard-operations-scheduling-card"
      firstColumnLabel="Schedule disruptions"
      range={range}
      variant="operations"
      loading={loading}
      scheduleOpsOverview={scheduleOpsOverview}
    />
  )
}
